"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeBasedHealingEffectHandler = exports.AttributeBasedHealingEffectArgs = void 0;
const CustomScript_1 = require("../../event-handlers/core/CustomScript");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class AttributeBasedHealingEffectArgs {
    constructor(abilityKey, attributeType, healingPercent) {
        this.abilityKey = abilityKey;
        this.attributeType = attributeType;
        this.healingPercent = healingPercent;
        this.__type = EffectType_1.EffectType.AttributeBasedHealing;
        this.__typeName = "AttributeBasedHealing";
        this.name = "Healing";
        this.harmful = false;
    }
}
exports.AttributeBasedHealingEffectArgs = AttributeBasedHealingEffectArgs;
let AttributeBasedHealingEffectHandler = class AttributeBasedHealingEffectHandler {
    apply(sequence, container, state) {
        const scriptArgs = {
            creatorId: state.creatorId,
            abilityKey: state.args.abilityKey,
            attributeType: state.args.attributeType,
            healingPercent: state.args.healingPercent,
        };
        state.meta.eventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, new CustomScript_1.CustomScriptEventHandlerArgs("Effect_AttributeBasedHealing", scriptArgs));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
AttributeBasedHealingEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.AttributeBasedHealing)
], AttributeBasedHealingEffectHandler);
exports.AttributeBasedHealingEffectHandler = AttributeBasedHealingEffectHandler;
